import Flickity from 'flickity';
import 'flickity-fade';
import 'flickity-imagesloaded';
import 'flickity/dist/flickity.min.css';
import 'flickity-fade/flickity-fade.css';

const Slider = (parentNode) => {
  if (!parentNode) return false;
 
  const flkty = new Flickity( parentNode.querySelector('.banner-slider-node'), {
    fade: true,
    setGallerySize: true,
    imagesLoaded: true
  });
}

export default Slider;